import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

var location = require('../../../../assets/images/location.png');

export default function PropertyBasicDetailsCard(props) {
	// console.log('PropertyBasicDetailsCard', props);

	let { id } = useParams();
	// console.log(id);

	const [
		property,
		setProperty
	] = useState([]);

	const [
		ownership,
		setOwnership
	] = useState([]);

	useEffect(() => {
		fetch(props.get_property_endpoint.replace('id', id))
			.then((response) => response.json())
			.then((result) => {
				setProperty(result.data || {});
				window.scrollTo({
					top: 2,
					left: 0,
					behavior: 'smooth'
				});
			});
	}, []);
	// console.log('get property data', property);

	useEffect(() => {
		fetch(
			props.get_property_ownership_by_property_endpoint.replace(
				'property_id',
				id
			)
		)
			.then((response) => response.json())
			.then((result) => {
				setOwnership(result.data[0] || {});
			});
	}, []);
	// console.log('get property ownership data', ownership);

	const formatPhoneNumber = (phoneNumber) => {
		// Check if the phone number is not empty
		if (phoneNumber) {
			// Remove non-numeric characters from the phone number
			const numericPhoneNumber = phoneNumber.replace(/\D/g, '');

			// Format the phone number with hyphens
			return numericPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
		}

		// Return an empty string if the phone number is empty
		return '';
	};

	return (
		<div className="PropertyBasicDetailsCard bg-white w-full min-w-96 mt-4 p-5 rounded-md shadow border text-gray-800">
			<div className="grid lg:grid-cols-12 lg:gap-5">
				<div className="col-span-12 lg:col-span-2">
					<h2 className="text-lg lg:text-xl font-semibold mb-2">
						Basic Details
					</h2>
				</div>
				<div className="col-span-12 lg:col-span-5 mb-5 lg:mb-0">
					<div className="border p-4 bg-gray-50 shadow-sm rounded-md">
						<Link
							key={property.id}
							to={`/properties/${id}/details`}
							state={{ propertyName: property.name, isEditing: true }}
						>
							<span className="float-right hover:underline">Edit</span>
						</Link>
						<div className="font-semibold">Address</div>
						<span className="block">{`${property.address_1}`}</span>
						<span className="block">
							{property.address_2 ? `${property.address_2}` : ''}
						</span>
						<span className="block">{`${property.city}, ${property.state} ${property.postal_code} `}</span>
						<span className="block">
							{property.county ? `${property.county} County` : ''}
						</span>
						<div className="hidden md:contents">
							<img
								src={location}
								className="mt-4 border shadow-sm rounded-md"
							/>
						</div>
					</div>
				</div>
				<div className="col-span-12 lg:col-span-5">
					<div className="border p-4 bg-gray-50 shadow-sm rounded-md">
						<Link
							key={property.id}
							to={`/properties/${id}/ownership`}
							state={{
								propertyId: property.id,
								propertyName: property.name,
								isEditing: true
							}}
						>
							<span className="float-right hover:underline">Edit</span>
						</Link>
						<div className="font-semibold">Ownership Type</div>
						<span className="block">
							{ownership.ownership_type ? ownership.ownership_type : '-'}
						</span>
						{ownership.entity_name && (
							<div className="grid md:grid-cols-12 mt-4">
								<div className="md:col-span-6">
									<div className="font-semibold">Entity Name</div>
									<span className="block">
										{ownership.entity_name ? ownership.entity_name : '-'}
									</span>
									<div className="font-semibold mt-4">
										Entity Registration Date
									</div>
									<span className="block">
										{ownership.entity_registration_date ? (
											new Date(
												ownership.entity_registration_date
											).toLocaleDateString()
										) : (
											'-'
										)}
									</span>
								</div>
								<div className="md:col-span-6 mt-4 md:mt-0">
									<div className="font-semibold">FEIN</div>
									<span className="block">
										{ownership.entity_federal_tax_id ? (
											'XX-XXX' +
											ownership.entity_federal_tax_id.substring(
												ownership.entity_federal_tax_id.length - 4
											)
										) : (
											'-'
										)}
									</span>
									<div className="font-semibold mt-4">Is Federally Taxed?</div>
									<span className="block">
										{ownership.entity_federally_taxed === true ? (
											'Yes'
										) : ownership.entity_federally_taxed === false ? (
											'No'
										) : (
											'-'
										)}
									</span>
								</div>
							</div>
						)}
						<div className="grid md:grid-cols-12 mt-4">
							<div className="md:col-span-6">
								<div className="font-semibold">
									Owner{' '}
									{ownership.owner_2_first_name &&
									ownership.owner_2_last_name && <span>1</span>}
								</div>
								<span className="block">
									{ownership.owner_1_first_name &&
									ownership.owner_1_last_name ? (
										ownership.owner_1_first_name +
										' ' +
										ownership.owner_1_last_name
									) : (
										'-'
									)}
								</span>
								<span className="block">
									{ownership.owner_1_phone_number ? (
										formatPhoneNumber(ownership.owner_1_phone_number)
									) : (
										''
									)}
								</span>
								<span className="block">
									{ownership.owner_1_email ? ownership.owner_1_email : ''}
								</span>
								<span className="block">
									{ownership.owner_1_ssn_itin ? (
										'*****' +
										ownership.owner_1_ssn_itin.substring(
											ownership.owner_1_ssn_itin.length - 4
										)
									) : (
										''
									)}
								</span>
							</div>
							<div className="md:col-span-6 mt-4 md:mt-0">
								{ownership.owner_2_first_name &&
								ownership.owner_2_last_name && (
									<div>
										<div className="font-semibold">Owner 2</div>
										<span className="block">
											{ownership.owner_2_first_name &&
											ownership.owner_2_last_name ? (
												ownership.owner_2_first_name +
												' ' +
												ownership.owner_2_last_name
											) : (
												'-'
											)}
										</span>
										<span className="block">
											{ownership.owner_2_phone_number ? (
												formatPhoneNumber(ownership.owner_2_phone_number)
											) : (
												''
											)}
										</span>
										<span className="block">
											{ownership.owner_2_email ? ownership.owner_2_email : ''}
										</span>
										<span className="block">
											{ownership.owner_2_ssn_itin ? (
												'*****' +
												ownership.owner_2_ssn_itin.substring(
													ownership.owner_2_ssn_itin.length - 4
												)
											) : (
												''
											)}
										</span>
									</div>
								)}
							</div>
						</div>
					</div>
					<div className="border p-4 mt-5 bg-gray-50 shadow-sm rounded-md">
						<Link
							key={property.id}
							to={`/properties/${id}/license-survey`}
							state={{
								propertyId: property.id,
								propertyName: property.name,
								isEditing: true
							}}
						>
							<span className="float-right hover:underline">Edit</span>
						</Link>
						<div className="font-semibold">License Survey</div>
					</div>
					<div className="border p-4 mt-5 bg-gray-50 shadow-sm rounded-md">
						<Link
							key={property.id}
							to={`/properties/${id}/business-license-application`}
							state={{
								propertyId: property.id,
								propertyName: property.name,
								isEditing: true
							}}
						>
							<span className="float-right hover:underline">Edit</span>
						</Link>
						<div className="font-semibold">License Application</div>
					</div>
				</div>
			</div>
		</div>
	);
}
